import Filter from './Filter.js';
import { addUnits, isNumeric } from './helpers.js';

/**
 * Handles Dropdown creation
 */
class Dropdown extends Filter {
  constructor(searchParameter, options, updateCallback, searchParameters) {
    super({ searchParameter, options, updateCallback, searchParameters });
    this.container = document.getElementById(searchParameter);
    this.placeholder = this.container.dataset.placeholder;
    this.key = this.container.dataset.key;
  }

  create() {
    let minValue, maxValue, id;

    this.container.classList.add('select-box');
    const dropdown = document.createElement('select');
    dropdown.classList.add(`${this.searchParameter}FilterDropdown`);
    dropdown.id = `dsp_${this.searchParameter}`;
    dropdown.name = `dsp_${this.searchParameter}[]`;

    this.container.appendChild(dropdown);
    let htmlOption = document.createElement('option');
    htmlOption.value = '';
    htmlOption.innerText = this.placeholder ? this.placeholder : 'Any';
    dropdown.appendChild(htmlOption);

    if (isNumeric(this.searchParameter)) {
      minValue = this.searchParameters[`${this.searchParameter}_min`]
        ? parseInt(this.searchParameters[`${this.searchParameter}_min`])
        : this.options.minValue;

      maxValue = this.searchParameters[`${this.searchParameter}_max`]
        ? parseInt(this.searchParameters[`${this.searchParameter}_max`])
        : (maxValue = this.options.maxValue);

      for (let i = this.options.minValue; i <= this.options.maxValue; i += this.options.step) {
        let htmlOption = document.createElement('option');
        htmlOption.innerText = `${addUnits(this.searchParameter, i)} - ${addUnits(
          this.searchParameter,
          i + this.options.step
        )}`;
        htmlOption.dataset.min = i;
        htmlOption.dataset.max = i + this.options.step;

        if (
          parseInt(htmlOption.dataset.max) == maxValue &&
          parseInt(htmlOption.dataset.min) == minValue
        ) {
          htmlOption.toggleAttribute('selected', true);
        }

        dropdown.appendChild(htmlOption);
      }
      return;
    }

    if (this.searchParameters[this.searchParameter]) {
      let valuesArray = this.searchParameters[this.searchParameter].split(',');
      if (valuesArray.length === 1) {
        id = valuesArray[0];
      }
    }

    if (!this.options) {
      this.container.dataset.optionCount = 0;
      return;
    }

    let optionCount = 0;
    this.options.forEach((option) => {
      const optionKey = this.getOptionKey(option);
      const htmlOption = document.createElement('option');
      let innerText = '';

      if (option.level === 0) {
        htmlOption.toggleAttribute('disabled', true);
        innerText = option.name /*+ ' (' + option.doc_count + ')'*/;
      } else {
        htmlOption.value = optionKey;

        if (dropdown.id === 'dsp_category') {
          innerText = '- ';
          htmlOption.classList.add('pl-3');
        }

        if (this.searchParameter == 'ext_colour') {
          innerText += `${option.id} (${option.doc_count})`;
        } else {
          innerText += `${option.name} (${option.doc_count})`;
        }

        if (option.name && !option.name.includes('(not specified)')) {
          htmlOption.setAttribute('data-option-name', option.name);
        }

        optionCount += 1;
      }

      if (typeof id !== 'undefined') {
        if (optionKey == id) {
          htmlOption.toggleAttribute('selected', true);
        }

        let shouldSelect = parseInt(id) == NaN ? false : option.id == id;

        if (typeof option.id !== 'undefined' && shouldSelect) {
          htmlOption.toggleAttribute('selected', true);
        }
      }

      htmlOption.innerText = innerText;
      dropdown.appendChild(htmlOption);
    });

    this.container.dataset.optionCount = optionCount;
  }

  update() {
    const dropdown = this.container.querySelector(`.${this.searchParameter}FilterDropdown`);
    const searchParameter = this.searchParameter;
    const searchParameters = this.searchParameters;

    dropdown.addEventListener('change', () => {
      if (isNumeric(searchParameter)) {
        searchParameters[`${searchParameter}_min`] =
          dropdown.querySelector('option:checked').dataset.min;
        searchParameters[`${searchParameter}_max`] =
          dropdown.querySelector('option:checked').dataset.max;
      } else {
        searchParameters[searchParameter] = dropdown.querySelector('option:checked').value;
      }

      this.container.dispatchEvent(new Event('dspFilter.change'));

      if (this.updateCallback && typeof this.updateCallback === 'function') {
        this.updateCallback(searchParameter);
      }
    });
  }

  getOptionKey(option) {
    let key = '';
    if (typeof this.key !== 'undefined') {
      key = option[this.key];
    } else {
      key = option.slug ?? option.id ?? option.name;
    }

    // The 'other-unsure' slug often does not work.
    if (key === 'other-unsure' && option.id) {
      key = option.id;
    }

    return key;
  }
}

export default Dropdown;
